
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVertical50 as ObiBatteryVertical50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-50.js';
 
 
 

 
 export const ObiBatteryVertical50 = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-50',
   elementClass: ObiBatteryVertical50Element,
   events: {
     
   }
  });
 
 